var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gray-bg assinatura-embed-wrapper",attrs:{"id":"page-wrapper"}},[_c('div',{staticClass:"row wrapper border-bottom white-bg page-heading"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',[_vm._v(_vm._s(_vm.$root.tituloDaPagina))])])]),_vm._v(" "),_c('div',{staticClass:"wrapper-content animated fadeIn"},[_c('router-view')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202f388f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/LayoutAssinaturaEmbed.vue
// module id = 1870
// module chunks = 0